export const timesheetStatus: any = {
	'1': 'TS - Invoiced',
	'2': 'TS - Occurred',
	'3': 'BK - Committed',
	'4': 'BK - Tenative'
};
